import React, { useEffect, useState } from 'react';
import Page from '../../components/Page';

//Material
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Avatar, Box, Grid, Menu, MenuItem, Rating, Stack, Typography } from '@mui/material';
// import { useNavigate, useSearchParams } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import basePhoto from '../../assets/DefaultIMG.png';
import { LetsGoBtn } from '../../components/Buttons';
import ServiceCard from '../../components/ServiceCard';
import { Spinner } from '../../components/Spinner';
// import { StyledTitle } from '../../components/StyledComponents';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import GridViewIcon from '@mui/icons-material/GridView';
// import ReplyIcon from '@mui/icons-material/Reply';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { useNavigate, useParams } from 'react-router-dom';
import ApiService from '../../helpers/apiHelper';

import DefaultAvatar from '../../assets/defaultPostImg.jpg';

import ImageGallery from 'react-image-gallery';
import RespondCard from '../../components/RespondCard';
import RespondForm from '../../components/RespondForm';
import { StyledTitle } from '../../components/StyledComponents';
import { dateFormattingByDate } from '../../helpers/date-helpers';
import {
  setIsOpenAuthModal,
  setIsOpenComplainModal,
  setIsOpenDeleteAttentionModal,
  setIsOpenDeleteModal,
  setIsOpenOrderAttentionModal,
  setIsOpenResendingModal,
  setIsOpenServiceModal,
  setIsOpenServicePromoteModal,
  setUserSavedServices
} from '../../redux/mainReducer';
import './index.css';

import { useSnackbar } from 'notistack';
import '../MainPage/index.css';
import { MoreHoriz } from '@mui/icons-material';
import { microdataServiceConstructor } from '../../helpers/metaHelper';
// import UserContactsModal from '../modals/UserContactsModal';

// const CssTextField = styled(TextField)({
//   '& label.Mui-focused': {
//     color: '#000000'
//   },
//   '& label': {
//     color: '#A1A1A1',

//   },
//   // '& .MuiInput-root.Mui-focused:after': {
//   //   borderBottom: '2px #000000 solid'
//   // },
//   // '& .MuiInput-root:hover:not(.Mui-disabled):before': {
//   //   borderBottom: '2px #000000 solid'
//   // },
//   // '& .MuiInput-root:not(.Mui-error):before': {
//   //   borderBottom: '2px #000000 solid'
//   // },
//   margin: '5px 0px'
// });

function ServicePage({ userData, language, blockedUsers, ...props }) {
  // const translate = useTranslate();
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [photos, setPhotos] = useState([]);
  // const [isLoadingPhotos, setIsLoadingPhotos] = useState(false);
  const [data, setData] = useState(null);
  const [microdata, setMicrodata] = useState(null);
  const [feedbacks, setFeedbacks] = useState([]);
  const [feedbacksQuery, setFeedbacksQuery] = useState({ page: 0, size: 4 });
  const [feedbacksTotalPages, setFeedbacksTotalPages] = useState(0);
  const [additionalGoods, setAdditionalGoods] = useState([]);
  const [isOpenFeedbackForm, setIsOpenFeedbackForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCanWriteFeedback, setIsCanWriteFeedback] = useState(false);
  const userSavedServices = useSelector((state) => state.global.userSavedServices);

  const [anchorEl, setAnchorEl] = useState(null);

  // const isOpenUserContactsModal = useSelector((state) => state.global.isOpenUserContactsModal);

  const apiSavedService = new ApiService('posts/saved-service');
  // const apiSavedService = new ApiService('saved-service');

  // const apiPhoto = new ApiService('photo/get-photo');
  // const apiPhoto = new ApiService('get-photo');

  const apiServicesSearch = new ApiService('posts/service/anotherUserServices');
  const apiServices = new ApiService('posts/service');
  const apiFeedback = new ApiService('posts/feedback');
  const apiComplaint = new ApiService('posts/service/complaint-service');
  const apiChats = new ApiService('notification/chats');
  const apiDelete = new ApiService(`posts/service`);

  //
  // const apiServicesSearch = new ApiService('service/anotherUserServices');
  // const apiServices = new ApiService('service');
  // const apiFeedback = new ApiService('feedback');
  // const apiComplaint = new ApiService('service/complaint-service');
  // const apiChats = new ApiService('chats');
  // const apiDelete = new ApiService(`service`);
  const deleteService = (id) => {
    apiDelete
      .deleteItem(id)
      .then((res) => {
        dataSetter();
        enqueueSnackbar('Товар успішно видалено', { variant: 'success' });
        dispatch(setIsOpenDeleteModal({ isOpen: false, text: '', func: null, id: null }));
      })
      .catch((error) => {
        if (
          error?.message &&
          error?.message === 'You cant delete this service because that have orders'
        ) {
          dispatch(setIsOpenDeleteAttentionModal(true));
        }
      });
  };
  const sendComplaint = (type, text) => {
    apiComplaint
      .updateDataID(data?.id, {
        complaintType: type,
        complaintDescription: text.length !== 0 ? text : null
      })
      .then((res) => {
        dispatch(setIsOpenComplainModal({ isOpen: false, func: null }));
        enqueueSnackbar('Скаргу надіслано.', { variant: 'success' });
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar('Сталась помилка.', { variant: 'error' });
      });
  };
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const dataSetter = () => {
    setIsLoading(true);
    apiServices
      .getItemById(params.id)
      .then((data) => {
        setIsLoading(false);
        setIsCanWriteFeedback(data?.result?.isCanWriteFeedback);
        apiFeedback
          .getItemById(`get-feedback-for-service/${params.id}`, { page: 0, size: 4 })
          .then((feedbacks) => {
            const micro = microdataServiceConstructor(
              data?.result?.id,
              data?.result?.nameService,
              data?.result?.userDTO?.nickname,
              data?.result?.photoUrls,
              `${window.location.origin}${window.location.pathname}`,
              data?.result?.currency,
              data?.result?.price,
              data?.result?.availability
            );
            setData(data.result);
            setMicrodata(micro);
            apiServicesSearch
              .getItemById(data.result.userDTO.id, {
                unnecessaryServiceId: params.id,
                size: 4,
                page: 0
              })
              .then((services) => {
                setAdditionalGoods(services.result);
              });
            setFeedbacks(feedbacks.result);
            setFeedbacksTotalPages(feedbacks?.total);
          });
      })
      .catch((error) => {
        if (error?.message) {
          if (error?.message.includes(`Service with serviceId [${params.id}] not found`)) {
            navigate(`/${language}/error`);
          }
          if (error?.message.includes(`Can't get service post`)) {
            navigate(`/${language}/error`);
          }
        } else {
          if (error === `Товар не активний!`) {
            navigate(`/${language}/error`);
          }
        }
      });
  };
  const feedbackRefresh = () => {
    apiFeedback
      .getItemById(`get-feedback-for-service/${params.id}`, {
        page: 0,
        size: (feedbacksQuery?.page + 1) * 4
      })
      .then((res) => {
        setFeedbacks(res.result);
        setFeedbacksTotalPages(res?.total);
      });
  };
  const feedbackSetter = (query) => {
    apiFeedback.getItemById(`get-feedback-for-service/${params.id}`, query).then((res) => {
      const newFeedbacks = [...feedbacks, ...res.result];
      setFeedbacks(newFeedbacks);
      setFeedbacksQuery({
        ...feedbacksQuery,
        page: feedbacksQuery.page + 1
      });
      setFeedbacksTotalPages(res?.total);
    });
  };
  useEffect(() => {
    if (params?.id) {
      dataSetter();
    }
    return () => {
      setFeedbacks([]);
      setFeedbacksQuery({ page: 0, size: 4 });
      setData(null);
      setAdditionalGoods([]);
    };
    // eslint-disable-next-line
  }, [params.id]);
  // eslint-disable-next-line
  const settings = {
    autoplay: false,
    dots: true,
    infinite: additionalGoods.length < 3 ? false : true,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true

    // beforeChange: (current, next) => setActiveSlide(next)a
  };
  useEffect(() => {
    let mounted = true;

    if (data?.photoUrls && data?.photoUrls.length !== 0 && mounted) {
      setPhotos([...data?.photoUrls]);
    } else {
      setPhotos([]);
    }
    return () => (mounted = false);
    // eslint-disable-next-line
  }, [data]);
  return (
    <Page
      title={data && data.nameService}
      description={data && data.description}
      microdata={data?.isPromotedProduct && microdata}
      isIndex={data?.isPromotedProduct}
      canonical={window.location.origin + window.location.pathname}
      sx={{
        display: 'flex',
        marginTop: '150px',
        alignItems: 'center',
        flexDirection: 'column',
        height: 'max-content',
        padding: {
          xs: '0px 20px 100px',
          sm: '0px 20px 100px',
          md: '0px 50px 100px',
          lg: '0px 100px 100px'
        }
      }}
    >
      {/* <UserContactsModal
        isSendDataRequest={isSendDataRequest}
        setIsSendDataRequest={setIsSendDataRequest}
        sendingData={{ type: 'service', id: params.id }}
        nickname={userData.nickname}
        isOpenModal={isOpenUserContactsModal}
        data={props.subscriptions}
      /> */}
      {data !== null && !isLoading ? (
        <Grid
          container
          spacing={5}
          sx={{
            maxWidth: '1440px'
            // // padding: '0px 100px',
            // marginTop: '100px'
          }}
        >
          {/* <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Typography
              variant="subtitle"
              sx={{
                display: 'inline-flex',
                cursor: 'pointer',
                color: 'black',
                ':hover': { color: '#60A5DF' }
              }}
              onClick={() => navigate(-1)}
            >
              <ReplyIcon sx={{ mr: 1, color: 'black' }} />
              Повернутись на попередню сторінку
            </Typography>
          </Grid> */}
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'start' }}
          >
            {photos && photos.length !== 0 ? (
              <ImageGallery
                infinite={true}
                style={{ marginTop: 0 }}
                showPlayButton={false}
                showBullets={false}
                showFullscreenButton={false}
                showThumbnails={photos.length > 1}
                renderLeftNav={(onClick) => (
                  <div
                    onClick={onClick}
                    style={{
                      display: 'flex',
                      width: '40px',
                      height: '40px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      position: 'absolute',
                      top: 'calc(50% - 15px)',
                      left: '5px',
                      zIndex: 99,
                      backgroundColor: 'rgba(255, 255, 255, 0.80)',
                      borderRadius: '50px',
                      boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                    }}
                  >
                    <ArrowBackIosIcon
                      sx={{
                        color: 'black',
                        fontSize: '24px',
                        cursor: 'pointer',
                        ml: '8px'
                      }}
                    />
                  </div>
                )}
                renderRightNav={(onClick) => (
                  <div
                    onClick={onClick}
                    style={{
                      display: 'flex',
                      width: '40px',
                      height: '40px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      position: 'absolute',
                      top: 'calc(50% - 15px)',
                      right: '5px',
                      zIndex: 99,
                      backgroundColor: 'rgba(255, 255, 255, 0.80)',
                      borderRadius: '50px',
                      boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                    }}
                  >
                    <ArrowForwardIosIcon
                      sx={{
                        color: 'black',
                        fontSize: '24px',
                        cursor: 'pointer'
                      }}
                    />
                  </div>
                )}
                items={photos.map((photo) => {
                  return {
                    original: photo,
                    thumbnail: photo,
                    originalHeight: 652,
                    originalWidth: 652,
                    thumbnailHeight: 652,
                    originalClass: 'service-photo-slide',
                    thumbnailClass: 'thumbnailSlide'
                  };
                })}
              />
            ) : null}
            {(data !== null && !data?.photoUrls) ||
            (data !== null && data?.photoUrls && data?.photoUrls.length === 0) ? (
              <img
                loading="lazy"
                src={basePhoto}
                alt="defaultImg"
                height={350}
                style={{ margin: '0px', objectFit: 'contain', maxWidth: '400px !important' }}
              />
            ) : null}

            {/* {isLoadingPhotos && (
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    mr: 1,
                    height: 390,
                    maxWidth: '100%'
                  }}
                >
                  {data.photoUrls.map((photo, index) => (
                    <Skeleton
                      sx={{ height: 96, width: 96, mt: index !== 0 ? 1 : 0, borderRadius: '5px' }}
                      animation="wave"
                      variant="rectangular"
                    />
                  ))}
                </Box>
                <Skeleton
                  sx={{ height: 390, width: '100%', borderRadius: '5px' }}
                  animation="wave"
                  variant="rectangular"
                />
              </Box>
            )} */}
          </Grid>
          <Grid item xs={12} sm={12} md={6} sx={{ position: 'relative' }}>
            <Menu
              disableScrollLock={true}
              anchorEl={anchorEl}
              id="action-menu"
              open={open}
              onClose={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'hidden',
                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                  borderRadius: '8px',
                  border: 'none',
                  p: { xs: '12px', sm: '12px', md: '20px' },
                  width: { xs: '380px', sm: '280px' },
                  mt: 1
                }
              }}
              autoFocus={false}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              {data?.userDTO?.id === userData?.id && !data?.isBlocked && (
                <MenuItem
                  sx={{
                    borderRadius: '4px',
                    ':hover': { backgroundColor: '#E2F2FF' },
                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    pl: '12px !important',
                    m: '0px 0px 2px !important'
                  }}
                  onClick={() => {
                    dispatch(
                      setIsOpenServiceModal({ isOpen: true, data: data, setter: dataSetter })
                    );
                    handleClose();
                  }}
                >
                  <Typography
                    component="p"
                    fontSize={16}
                    sx={{ lineHeight: '18px' }}
                    fontWeight={400}
                  >
                    Редагувати
                  </Typography>
                </MenuItem>
              )}
              {data?.userDTO?.id === userData?.id && !data?.isBlocked && (
                <MenuItem
                  sx={{
                    borderRadius: '4px',
                    ':hover': { backgroundColor: '#E2F2FF' },
                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    pl: '12px !important',
                    m: '2px 0px !important'
                  }}
                  onClick={() => {
                    if (userData.role === 'PREMIUM_USER') {
                      dispatch(
                        setIsOpenServicePromoteModal({
                          isOpen: true,
                          id: data?.id,
                          title: data?.nameService,
                          setter: null
                        })
                      );
                      handleClose();
                    } else {
                      navigate('/ua/tariffs');
                    }
                  }}
                >
                  <Typography
                    component="p"
                    fontSize={16}
                    sx={{ lineHeight: '18px' }}
                    fontWeight={400}
                  >
                    Просувати
                  </Typography>
                </MenuItem>
              )}
              {userData && userData?.id && (
                <MenuItem
                  sx={{
                    borderRadius: '4px',
                    ':hover': { backgroundColor: '#E2F2FF' },
                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    pl: '12px !important',
                    m: '2px 0px !important'
                  }}
                  onClick={() => {
                    dispatch(
                      setIsOpenResendingModal({ isOpen: true, id: params.id, type: 'service' })
                    );
                    handleClose();
                  }}
                >
                  <Typography
                    component="p"
                    fontSize={16}
                    sx={{ lineHeight: '18px' }}
                    fontWeight={400}
                  >
                    Відправити у повідомлення
                  </Typography>
                </MenuItem>
              )}

              <MenuItem
                sx={{
                  borderRadius: '4px',
                  ':hover': { backgroundColor: '#E2F2FF' },
                  fontFamily: 'FixelText-Medium',
                  fontWeight: '500',
                  pl: '12px !important',
                  m: '2px 0px !important'
                }}
                onClick={() => {
                  navigator.clipboard.writeText(`${window.location.origin}/ua/service/${data?.id}`);
                  handleClose();
                  enqueueSnackbar('Посилання на товар скопійовано', { variant: 'success' });
                }}
              >
                <Typography
                  component="p"
                  fontSize={16}
                  sx={{ lineHeight: '18px' }}
                  fontWeight={400}
                >
                  Скопіювати посилання
                </Typography>
              </MenuItem>

              {userData && userData?.id && data?.userDTO?.id !== userData?.id && (
                <MenuItem
                  sx={{
                    borderRadius: '4px',
                    ':hover': { backgroundColor: '#FFE5E5' },

                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    color: '#F64D36',
                    pl: '12px !important',
                    m: '2px 0px !important'
                  }}
                  onClick={() => {
                    dispatch(setIsOpenComplainModal({ isOpen: true, func: sendComplaint }));
                    handleClose();
                  }}
                >
                  <Typography
                    component="p"
                    fontSize={16}
                    sx={{ lineHeight: '18px' }}
                    fontWeight={400}
                  >
                    Поскаржитись
                  </Typography>
                </MenuItem>
              )}
              {data?.userDTO?.id === userData?.id && (
                <MenuItem
                  sx={{
                    borderRadius: '4px',
                    ':hover': { backgroundColor: '#FFE5E5' },

                    fontFamily: 'FixelText-Medium',
                    fontWeight: '500',
                    color: '#F64D36',
                    pl: '12px !important',
                    m: '2px 0px !important'
                  }}
                  onClick={() => {
                    handleClose();
                    dispatch(
                      setIsOpenDeleteModal({
                        isOpen: true,
                        text: 'цей товар?',
                        func: deleteService,
                        id: data?.id
                      })
                    );
                  }}
                >
                  Видалити товар
                </MenuItem>
              )}
            </Menu>

            <Stack spacing={0} flexDirection="column">
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{ color: '#7C7C7C', fontSize: '16px' }} variant="subtitle">
                  {dateFormattingByDate(new Date(data.creationTimeForService))}
                </Typography>
                <Stack spacing={4} flexDirection="row" sx={{ alignItems: 'center', gap: '24px' }}>
                  <SendOutlinedIcon
                    onClick={() => {
                      if (userData && userData?.id) {
                        if (!data?.isBlocked) {
                          dispatch(
                            setIsOpenResendingModal({
                              isOpen: true,
                              id: params.id,
                              type: 'service'
                            })
                          );
                        }
                      } else {
                        dispatch(setIsOpenAuthModal(true));
                      }
                    }}
                    sx={{
                      width: '23px',
                      height: '30px',
                      margin: '0px  !important',
                      transform: 'rotate(315deg)',
                      color: data?.isBlocked && 'lightgray',
                      cursor: !data?.isBlocked ? 'pointer' : 'default',
                      '&:hover': {
                        color: !data?.isBlocked ? '#60A5DF' : 'lightgray'
                      }
                    }}
                  />
                  {userData &&
                  userSavedServices.length !== 0 &&
                  userSavedServices.includes(data.id) ? (
                    <BookmarkIcon
                      onClick={() => {
                        if (userData && userData?.id) {
                          if (!data?.isBlocked) {
                            apiSavedService.deleteItemQuery({ postId: data.id }).then((res) => {
                              // dataSetter();
                              const newArray = userSavedServices.filter((id) => data.id !== id);
                              dispatch(setUserSavedServices([...newArray]));
                            });
                          }
                        } else {
                          dispatch(setIsOpenAuthModal(true));
                        }
                      }}
                      sx={{
                        width: '25px',
                        height: '40px',
                        marginTop: '0px !important',
                        cursor: 'pointer',
                        color: !data?.isBlocked ? 'rgb(239, 201, 56)' : 'lightgray',
                        ':hover': {
                          color: !data?.isBlocked ? 'rgb(239, 201, 56)' : 'lightgray',
                          cursor: !data?.isBlocked ? 'pointer' : 'default'
                        }
                      }}
                    />
                  ) : (
                    <BookmarkBorderOutlinedIcon
                      onClick={() => {
                        if (userData && userData?.id) {
                          if (!data?.isBlocked) {
                            apiSavedService
                              .updateDataQueryPost({ serviceId: data.id })
                              .then((res) => {
                                // dataSetter();
                                const newArray = [...userSavedServices, data.id];
                                dispatch(setUserSavedServices([...newArray]));
                              });
                          }
                        } else {
                          dispatch(setIsOpenAuthModal(true));
                        }
                      }}
                      sx={{
                        width: '25px',
                        height: '40px',
                        marginTop: '0px !important',
                        color: data?.isBlocked && 'lightgray',
                        cursor: !data?.isBlocked ? 'pointer' : 'default',
                        '&:hover': {
                          color: !data?.isBlocked ? '#EFC938' : 'lightgray'
                        }
                      }}
                    />
                  )}

                  <Box
                    id="positioned-button"
                    onClick={(event) => handleClick(event)}
                    sx={{
                      marginTop: '0px !important',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: { xs: '30px', sm: '40px' },
                      height: { xs: '30px', sm: '40px' },
                      backgroundColor: 'white',
                      cursor: 'pointer',
                      boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                      borderRadius: '50px',
                      zIndex: 102
                    }}
                  >
                    {' '}
                    <MoreHoriz sx={{ cursor: 'pointer' }} />
                  </Box>
                </Stack>
              </Box>

              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '32px !important',
                  fontFamily: 'FixelText-Medium'
                }}
                variant="h1"
              >
                {data.nameService}
              </Typography>
              <Typography
                sx={{
                  fontSize: '16px',
                  lineHeight: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  color: '#60A5DF',
                  fontWeight: '500',
                  fontFamily: 'FixelText-Medium'
                }}
              >
                <GridViewIcon
                  sx={{
                    fontSize: '24px',
                    color: '#60A5DF',
                    marginRight: '8px',
                    marginBottom: '2px'
                  }}
                />
                {data.category}
              </Typography>
              <Typography
                sx={{
                  fontWeight: '600',
                  fontSize: '32px !important',
                  color: '#1B1B1B',
                  fontFamily: 'FixelText-Medium',
                  mt: '16px',
                  display: 'flex',
                  alignItems: 'center'
                }}
                variant="h2"
              >
                {`${data.price} ${data.currency}`}
                <Typography
                  sx={{
                    fontWeight: '500',
                    fontSize: '20px !important',
                    fontFamily: 'FixelText-Medium',
                    color: '#7C7C7C',
                    ml: '12px'
                  }}
                >
                  {` / ${data.valueOfInitOfMeasure}${data.initOfMeasure}`}
                </Typography>
              </Typography>
              <Typography
                sx={
                  data?.availability === 'Є в наявності'
                    ? {
                        fontSize: '20px',
                        color: '#29A10E',
                        display: 'flex',
                        fontFamily: 'FixelText-Medium',
                        fontWeight: '500'
                      }
                    : {
                        fontSize: '20px',
                        color: 'red',
                        display: 'flex',
                        fontFamily: 'FixelText-Medium',
                        fontWeight: '500'
                      }
                }
              >
                {data.availability}
              </Typography>

              <Typography
                sx={{
                  fontSize: '16px',

                  fontFamily: 'FixelText-Medium',
                  color: '#7C7C7C',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {data?.numberFeedbacks !== 0 ? `відгуки: ${data?.numberFeedbacks}` : null}
                <Rating
                  sx={{
                    fontSize: '18px',
                    ml: data?.numberFeedbacks !== 0 ? '10px' : '0px',
                    mb: '4px'
                  }}
                  value={data.rating}
                  precision={0.5}
                  readOnly
                />
              </Typography>
              {data?.isBlocked ? (
                <Box
                  sx={{
                    border: '1px solid red',
                    borderRadius: '5px',
                    display: 'flex',
                    padding: '10px',
                    alignItems: 'center',
                    mt: '10px'
                  }}
                >
                  <ErrorOutlineOutlinedIcon sx={{ color: 'red', mr: '10px' }} />
                  <Typography sx={{ fontWeight: '600', fontSize: '14px', color: 'red' }}>
                    Товар заблоковано адміністратором та є недоступним для інших користувачів.
                    Зверніться в службу підтримки за деталями.{' '}
                  </Typography>
                </Box>
              ) : null}
              <Grid container spacing={1} sx={{ display: 'flex', mt: 2 }}>
                {data.paymentOption.length !== 0 && (
                  <Grid item xs={7} sm={4} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        mb: 1,
                        fontSize: 20,
                        fontFamily: 'FixelText-Medium',
                        fontWeight: '500'
                      }}
                    >
                      Оплата:
                    </Typography>
                    {data.paymentOption.includes('Повна оплата') && (
                      <Typography
                        variant="body2"
                        sx={{
                          mb: 1,
                          fontSize: 16,
                          fontFamily: 'FixelText-Regular',
                          display: 'inline-flex',
                          color: '#7C7C7C',
                          lineHeight: '26px'
                        }}
                      >
                        Повна оплата
                      </Typography>
                    )}
                    {data.paymentOption.includes('Часткова передоплата') && (
                      <Typography
                        variant="body2"
                        sx={{
                          mb: 1,
                          fontSize: 16,
                          fontFamily: 'FixelText-Regular',
                          display: 'inline-flex',
                          color: '#7C7C7C',
                          lineHeight: '26px'
                        }}
                      >
                        Часткова передоплата
                      </Typography>
                    )}
                    {data.paymentOption.includes('Оплата при отриманні') && (
                      <Typography
                        variant="body2"
                        sx={{
                          mb: 1,
                          fontSize: 16,
                          fontFamily: 'FixelText-Regular',
                          display: 'inline-flex',
                          color: '#7C7C7C',
                          lineHeight: '26px'
                        }}
                      >
                        Оплата при отриманні
                      </Typography>
                    )}
                  </Grid>
                )}
                {data.deliveryOption.length !== 0 && (
                  <Grid item xs={5} sm={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        mb: 1,
                        fontSize: 20,
                        fontFamily: 'FixelText-Medium',
                        fontWeight: '500'
                      }}
                    >
                      Доставка:
                    </Typography>

                    {data.deliveryOption.includes('УкрПошта') && (
                      <Typography
                        variant="body2"
                        sx={{
                          mb: 1,
                          fontSize: 16,
                          fontFamily: 'FixelText-Regular',
                          display: 'inline-flex',
                          color: '#7C7C7C',
                          lineHeight: '26px'
                        }}
                      >
                        УкрПошта
                      </Typography>
                    )}

                    {data.deliveryOption.includes('Нова Пошта') && (
                      <Typography
                        variant="body2"
                        sx={{
                          mb: 1,
                          fontSize: 16,
                          fontFamily: 'FixelText-Regular',
                          display: 'inline-flex',
                          color: '#7C7C7C',
                          lineHeight: '26px'
                        }}
                      >
                        Нова Пошта
                      </Typography>
                    )}
                    {data.deliveryOption.includes("Кур'єр") && (
                      <Typography
                        variant="body2"
                        sx={{
                          mb: 1,
                          fontSize: 16,
                          fontFamily: 'FixelText-Regular',
                          display: 'inline-flex',
                          color: '#7C7C7C',
                          lineHeight: '26px'
                        }}
                      >
                        Кур'єр
                      </Typography>
                    )}
                  </Grid>
                )}
              </Grid>
            </Stack>

            <Typography
              variant="subtitle2"
              sx={{
                fontFamily: 'FixelText-Medium',
                fontSize: '20px',
                marginTop: '16px !important',
                marginBottom: '8px !important',
                textAlign: 'left',
                fontWeight: '500'
              }}
            >
              Продавець:
            </Typography>
            <Stack
              flexDirection="row"
              sx={{
                p: '8px',
                boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                backgroundColor: 'white',
                borderRadius: '8px',
                alignItems: 'center'
              }}
            >
              <Avatar
                src={
                  data?.userDTO && data?.userDTO?.photoUrl ? data?.userDTO?.photoUrl : DefaultAvatar
                }
                onClick={() => navigate(`/${language}/user-page/${data.userDTO.id}?type=posts`)}
                sx={{
                  width: { xs: 60, sm: 80 },
                  height: { xs: 60, sm: 80 },
                  border: 'none',
                  mr: { xs: '8px', sm: '24px' },
                  cursor: 'pointer',
                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                  // boxShadow: blockedUsers.find(
                  //   (user) => user.id === el?.userDTO?.id || user.id === el?.userRibbonDTO?.id
                  // )
                  //   ? '0px 0px 2px 2px rgba(255,0,0,1)'
                  //   : 'none'
                }}
              />
              <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '15px' }}>
                <Typography
                  variant="subtitle"
                  sx={{
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: 14, sm: 16 },
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontWeight: '400',
                    color: '#7C7C7C'
                  }}
                  onClick={() => navigate(`/${language}/user-page/${data.userDTO.id}?type=posts`)}
                >
                  {`@${data?.userDTO && data.userDTO.nickname}`}
                </Typography>
                {data?.userDTO && data?.userDTO?.name && data?.userDTO?.surname && (
                  <Typography
                    variant="subtitle"
                    sx={{
                      fontFamily: 'FixelText-Medium !important',
                      fontSize: { xs: '16px', sm: '20px' },
                      textAlign: 'left',
                      cursor: 'pointer',
                      fotWeight: '500'
                    }}
                    onClick={() => navigate(`/${language}/user-page/${data.userDTO.id}?type=posts`)}
                  >
                    {`${data?.userDTO && data?.userDTO?.name} ${
                      data?.userDTO && data?.userDTO?.surname
                    }`}
                  </Typography>
                )}
              </div>
            </Stack>

            {data?.userDTO &&
              data.userDTO?.id !== userData.id &&
              data.availability !== 'Немає в наявності' &&
              !blockedUsers.find((el) => el.id === data?.userDTO?.id) && (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: '12px',
                    mt: '12px'
                  }}
                >
                  <LetsGoBtn
                    disabled={data.availability === 'Немає в наявності'}
                    colorScheme="blue"
                    onClick={() => {
                      if (userData && userData?.id) {
                        if (data?.opportunityOrdering) {
                          navigate(`/${language}/order-page/${data.id}`);
                        } else {
                          dispatch(setIsOpenOrderAttentionModal(true));
                        }
                      } else {
                        dispatch(setIsOpenAuthModal(true));
                      }
                    }}
                    text={
                      data.availability === 'Немає в наявності' ? 'Немає у наявності' : 'Замовити'
                    }
                    width="100%"
                  />
                  <LetsGoBtn
                    colorScheme="white"
                    onClick={() => {
                      if (userData && userData?.id) {
                        apiChats
                          .postDataQuery({
                            userId: userData.id,
                            recipientId: data?.userDTO?.id
                          })
                          .then((res) => {
                            navigate(`/${language}/messages`);
                          })
                          .catch((error) => {
                            if (error?.message.includes('There is a chat between these users')) {
                              const id = `${error.message.slice(
                                error.message.indexOf('[') + 1,
                                error.message.length - 1
                              )}`;

                              navigate(`/${language}/messages?chatId=${id}`);
                            }
                          });
                      } else {
                        dispatch(setIsOpenAuthModal(true));
                      }
                    }}
                    text="Написати продавцю"
                    width="100%"
                  />
                </Box>
              )}
          </Grid>
          {data?.description && data?.description?.length !== 0 ? (
            <Grid item xs={12} sx={{ position: 'relative' }}>
              <Typography
                variant="h3"
                sx={{
                  fontFamily: 'FixelText-SemiBold',
                  fontSize: '24px !important',

                  marginBottom: '8px !important',
                  textAlign: 'left',
                  fontWeight: '600'
                }}
              >
                Опис:
              </Typography>
              <Typography
                sx={{ fontSize: '16px', textAlign: 'left', fontWeight: '500' }}
                children={data?.description
                  .split('\r\n')
                  .filter((el) => el.length !== 0)
                  .map((string, index) => {
                    return (
                      <p key={index} style={{ margin: '0' }}>
                        {string}
                        <br />
                      </p>
                    );
                  })}
              />
            </Grid>
          ) : null}

          <Grid item xs={12} sx={{ mt: 6 }}>
            <StyledTitle
              variant="h2"
              sx={{
                margin: '0px auto !important'
              }}
              // className="bottomBlock-title"
            >
              Що кажуть користувачі
            </StyledTitle>
            <Grid container spacing={2}>
              {(data?.userDTO && data.userDTO.id !== userData.id && feedbacks.length === 0) ||
              (!data?.userDTO && feedbacks.length === 0) ? (
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: '20px' }}>
                  <Typography fontSize={16} sx={{ textAlign: 'center' }}>
                    У цього товару поки що немає відгуків.
                    {isCanWriteFeedback && ' Напиши перший відгук!'}
                  </Typography>
                </Grid>
              ) : null}

              <Grid
                item
                xs={12}
                sx={
                  feedbacks.length === 0
                    ? {
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '20px',
                        flexDirection: 'column',
                        alignItems: 'center'
                      }
                    : { marginBottom: '20px' }
                }
              >
                {!isOpenFeedbackForm && isCanWriteFeedback ? (
                  <>
                    {(data?.userDTO &&
                      data?.userDTO.id !== userData.id &&
                      !blockedUsers.find((el) => el.id === data?.userDTO?.id)) ||
                    !data?.userDTO ? (
                      <LetsGoBtn
                        colorScheme="blue"
                        disabled={blockedUsers.find((el) => el.id === data?.userDTO?.id)}
                        text="Додати відгук"
                        width="180px"
                        onClick={() => setIsOpenFeedbackForm(true)}
                      />
                    ) : null}
                  </>
                ) : null}

                {isOpenFeedbackForm && (
                  <RespondForm
                    id={data.id}
                    feedbackSetter={feedbackRefresh}
                    setIsOpenFeedbackForm={setIsOpenFeedbackForm}
                    setIsCanWriteFeedback={setIsCanWriteFeedback}
                  />
                )}
              </Grid>
              {feedbacks.map((feedback, index) => (
                <Grid
                  key={`feedback${index}`}
                  item
                  xs={12}
                  sx={{ display: 'flex', justifyContent: 'center' }}
                >
                  <RespondCard
                    data={feedback}
                    serviceOwnerId={data?.userDTO?.id}
                    setter={feedbackRefresh}
                    setIsCanWriteFeedback={setIsCanWriteFeedback}
                  />
                </Grid>
              ))}

              {feedbacks.length !== 0 &&
                feedbacksTotalPages !== 1 &&
                feedbacksQuery?.page !== feedbacksTotalPages - 1 && (
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <LetsGoBtn
                      colorScheme="white"
                      onClick={() => {
                        feedbackSetter({
                          ...feedbacksQuery,
                          page: feedbacksQuery.page + 1
                        });
                      }}
                      text="Завантажити ще"
                      width="fit-content"
                    />
                  </Grid>
                )}

              {data?.userDTO && data.userDTO.id === userData.id && feedbacks.length === 0 && (
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: '20px' }}>
                  <Typography fontSize={16}>У вас поки що немає відгуків. </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
          {data?.userDTO && data.userDTO.id !== userData.id && (
            <Grid item xs={12} sx={{ mt: 6 }}>
              {additionalGoods.length !== 0 && (
                <StyledTitle
                  maxWidth={800}
                  sx={{
                    lineHeight: '38px !important',
                    fontSize: '32px !important',
                    textTransform: 'initial !important'
                  }}
                  className="bottomBlock-title"
                >
                  Інші товари продавця
                </StyledTitle>
              )}

              <Grid container style={{ width: '1440px !important', gap: { xs: '16px', sm: 0 } }}>
                {additionalGoods.map((card, index) => (
                  <Grid
                    key={`services${index}`}
                    item
                    xs={12}
                    sm={4}
                    sx={{ display: 'flex', justifyContent: 'center' }}
                  >
                    <ServiceCard el={card} isServicePage={true} />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          )}
        </Grid>
      ) : (
        <div
          style={{
            // height: '240px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginBottom: '100px',
            height: '100vh'
          }}
        >
          <Spinner />
        </div>
      )}
    </Page>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    subscriptions: state.global.userSubscriptions,
    blockedUsers: state.global.blockedUsers
  };
};
export default connect(mapStateToProps)(ServicePage);
